<template>
    <div>
        <base-input
            v-model="form.name"
            validate="required"
            name="name"
            label="Name"
            placeholder="eg: The Avengers"/>

        <base-text-area
            v-model="form.description"
            name="description"
            label="Description"/><br/>

        <base-button
            icon="fas fa-check"
            @click="submit"
            :loading="loading"
            class="is-primary"
            text="Save"/> &nbsp;

        <base-button
            icon="fas fa-times"
            @click="$emit('cancel')"
            class="is-danger"
            text="Cancel"/>
    </div>
</template>

<script>
import { copy } from '../../utils/helpers';

export default {
    name: 'TeamForm',
    props: ['loading', 'initData'],
    data() {
        return {
            form: this.initData || { name: '', description: '' },
        };
    },
    methods: {
        submit() {
            this.$validator.validate().then((result) => {
                if (!result) return;
                this.$emit('submit', copy(this.form));
                this.form.name = '';
                this.form.description = '';
            });
        },
    },
};
</script>
